import React from "react";
import { FaGithub } from "react-icons/fa";

import "./style.scss";

import Navbar from "./navbar";

const Header = ({ children, siteTitle }) => <Navbar />;

export default Header;
